<template>
<div id="demo-basic-card">
  <vx-card class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">검토 시험</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem :type="true" v-if="exam.test_state != 1" v-for="(exam, index) in userExamList" @state="setExamState" :examInfo="exam" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <vx-card class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">검토중</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem v-for="(exam, index) in testExamList" @state="setExamState" :examInfo="exam" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <vx-card class="box" style="margin-bottom:20px" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' scrollHeight>
        <div slot="header">검토 완료</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem v-for="(exam, index) in adminExamList" @state="setExamState" :examInfo="exam" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <!-- <vx-card class="box" style="margin-bottom:20px">
    <vs-collapse>
      <vs-collapse-item id='collapse'>
        <div slot="header">진행 중인 시험</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem v-for="(exam, index) in currentExamList" :examInfo="exam" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card> -->
</div>
</template>

<script>
import ExamItem from './ExamItem.vue'

export default {
  components: {
    'ExamItem':ExamItem,
  },
  data() {
    return {
      title: 'AClass',
      workspacePopup: false,
      examInfo: {
        'id': 0,
        'start_time': null,
        'end_time': null,
        'info': 'high',
        'grade': '1',
        'test_name': '',
        'institute': '',
        'state': 0,
        'release_time': '',
        'exam_version': '',
        'total_score': 0
      }
    }
  },
  created() {
    // if (this.adminExamList.length == 0) {
      this.$store.dispatch('etest/getEtestExam', 'admin')
        // .then(() => {
        //   this.$store.dispatch('etest/getEtestExam', 'admin_test')
        // })
    // }
    // this.$store.dispatch('etest/getEtestExam', 'current')

  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    writingExamList() {
      return this.$store.state.etest.writingExamList
    },
    scheduleExamList() {
      return this.$store.state.etest.scheduleExamList
    },
    currentExamList() {
      return this.$store.state.etest.currentExamList
    },
    adminExamList() {
      return this.$store.state.etest.adminExamList
    },
    userExamList() {
      return this.$store.state.etest.userExamList
    },
    testExamList() {
      return this.$store.state.etest.testExamList
    }
  },
  methods: {
    setExamState(val) {
      var count = 0
      var testState = 0
        if(val.state > 0) {
          testState = 1
         if(val.state == 2) {
          count = 1
          }
        }
      console.log(count , testState)
      this.$store.dispatch('etest/updateAdminExamState', {
          'id': val.exam_id,
          'admin_check': count
        }).then(()=> {
          console.log(testState)
          this.$store.dispatch('etest/updateAdminTestState', {
              'id': val.exam_id,
              'test_state': testState
            }).then(()=> {
              this.$store.dispatch('etest/getEtestExam', 'admin')
            })
        })
    },
    createExam() {
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/0')
    },
  }
}
</script>


<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
}
</style>
